import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import { CONFIRM_EMAIL, FETCH_USER, FETCH_SITES } from 'src/store/types';
import { setAuthHeader } from 'src/utils/auth';
import TopBar from "components/TopBar.vue";
export default Vue.extend({
    components: { TopBar },
    data() {
        return {
            confirming: true
        };
    },
    computed: {
        ...mapGetters([
            'hasRequestErrors', 'serverErrors', 'availableSites'
        ])
    },
    mounted() {
        this.doConfirmation(this.$route.params.key);
    },
    methods: {
        ...mapActions({ CONFIRM_EMAIL, FETCH_USER, FETCH_SITES }),
        async doConfirmation(key) {
            this.confirming = true;
            try {
                const data = await this.CONFIRM_EMAIL({ key });
                // ok if we got a response we have a auth key and so set
                // auth headers and request the user as though we had logged on
                setAuthHeader({ botanicToken: data?.key });
                await this.FETCH_USER();
                // now that we are logged in:
                await this.FETCH_SITES();
                //if this user belongs to only one site then go there or go to the start page
                if (this.availableSites.length === 1) {
                    this.$router.push({ name: 'home', params: { site: this.availableSites[0].domain } });
                }
                else {
                    this.$router.push({ name: 'start' });
                }
            }
            catch (error) {
                // we shouldn't get an error here because the vuex actions will deal with it
                // and update serverErrors, etc
                // but in future that could change so this is just a placeholder
            }
            finally {
                this.confirming = false;
            }
        }
    }
});
